import React from 'react';
import { LinkButton, LinkWrapper } from 'app/components/competitionModule/link/styles';
import { Skeleton } from '@mui/material';
export default function LinkSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(LinkWrapper, {
    "data-sentry-element": "LinkWrapper",
    "data-sentry-component": "LinkSkeleton",
    "data-sentry-source-file": "LinkSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    "data-sentry-element": "LinkButton",
    "data-sentry-source-file": "LinkSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 80,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "LinkSkeleton.tsx"
  })));
}